module.exports = __webpack_public_path__ + "static/affymetrix-c4497d5aa358323b5a007effce3837f5.png";